import { __extends } from "tslib";
import * as React from 'react';
import { RenderHtml } from '../../../utils';
var MarkdownComponent = /** @class */ (function (_super) {
    __extends(MarkdownComponent, _super);
    function MarkdownComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MarkdownComponent.prototype.render = function () {
        var maybeRenderedHtml = this.props.value.renderedHtml;
        return (React.createElement("div", { className: 'component markdown-component', "data-component-type": 'markdown' },
            React.createElement(RenderHtml, { html: maybeRenderedHtml, className: 'rendered-html' })));
    };
    return MarkdownComponent;
}(React.PureComponent));
export { MarkdownComponent };
//# sourceMappingURL=markdown-component.comp.js.map